import { EDealType, EObjectTypeFlat, EOfferType, ISelectRealtorFormState } from '@cian/valuation-main-filters-widget';

/**
 * Хук возвращает начальное значение для блока фильтров
 * Оставляет фильтры пустыми или предзаполняет, в зав-ти от эксперимента
 * */
export const useInitialFiltersState = (): Partial<ISelectRealtorFormState> => {
  return {
    dealType: EDealType.Buy,
    offerType: EOfferType.Flat,
    objectType: EObjectTypeFlat.Flat,
  };
};
